import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const AnnouncementBanner: React.FC = () => {
  const [isDismissed, setIsDismissed] = useState(true);

  useEffect(() => {
    // Check if user has dismissed the banner
    const dismissed = localStorage.getItem("hubPlusBannerDismissed");
    if (!dismissed) {
      setIsDismissed(false);
    }
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem("hubPlusBannerDismissed", "true");
  };

  if (isDismissed) {
    return null;
  }

  return (
    <div
      className="sticky top-0 z-10 flex h-16 shrink-0 items-center border-b border-gray-200 shadow-sm px-4 sm:px-6 lg:px-8"
      style={{ backgroundColor: "#B20030" }}
    >
      {/* Avatar */}
      <div className="flex-shrink-0 mr-3">
        <img
          alt="Announcement"
          className="w-8 h-8 rounded-full object-cover"
          src="https://staticfiles.gleap.io/g646e1a9b64619a3835c7b39c/Cf893qivlFE57wXPEZ0VSUo0wlW9TYdDaFysZ7du92QwRig7McA5rRsXxlWu9twHtrwjT4yJvp4.png"
        />
      </div>

      {/* Message Content */}
      <div className="flex-1 text-white min-w-0">
        <div className="font-bold text-sm flex items-center gap-2">
          <span>🚀</span>
          <span>Welcome to the New Hub+!</span>
          <span className="hidden sm:inline text-xs font-normal opacity-90">
            - You're now using our brand-new platform. Enjoy!
          </span>
        </div>
      </div>

      {/* Dismiss Button */}
      <button
        aria-label="Dismiss banner"
        className="flex-shrink-0 text-white hover:bg-white/20 rounded-full p-1.5 transition-colors ml-2"
        onClick={handleDismiss}
        type="button"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
};

export default AnnouncementBanner;
